// Vue.js
import Vue from "vue";
// Main Component
import App from "./App.vue";
// SweetAlert.js
import VueSweetalert2 from 'vue-sweetalert2';
// Vuetify
import vuetify from "@/plugins/vuetify";
// VueRouter
import router from "./router";
// Sentry
import * as Sentry from "@sentry/vue";
// Vuex Store
import store from "./store";
// AdminLTE Dependencies
import Treeview from "../src/assets/scripts/TreeView";
import PushMenu from "../src/assets/scripts/PushMenu";

// Style Dependencies
// Bootstrap
import '@/assets/styles/tailwind.css';
import { BootstrapVue } from 'bootstrap-vue';
import "bootstrap/dist/js/bootstrap.bundle";
import bootstrap from 'bootstrap';
import "./assets/styles/tailwind.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap-vue/dist/bootstrap-vue.css';

// SweetAlert
import "sweetalert2/dist/sweetalert2.min.css";
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';

// Styles
import "./assets/styles/main.css";
import "./assets/scss/_base.scss";
import "./assets/scss/_layout.scss";
import "./assets/scss/_module.scss";
import "./assets/scss/_state.scss";
import "./assets/scss/_theme.scss";

import VueApexCharts from 'vue-apexcharts';

Vue.config.performance = process.env.NODE_ENV !== "production";

Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);


Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);

Sentry.init({
  Vue: Vue,
  App,
  dsn: "https://899b960d86702732c6955c3b5e15d04b@o4507865117818880.ingest.de.sentry.io/4508477033349200",
  integrations: [],
});

new Vue({
  router,
  vuetify,
  store,
  bootstrap,
  Treeview,
  PushMenu,
  render: h => h(App)
  // created() {
  //   window.addEventListener('beforeunload', this.getUserData);
  // },
  // destroyed() {
  //   window.removeEventListener('beforeunload', this.getUserData);
  // },
  // methods: {
  //   getUserData(event) {

  //   }
  // },
}).$mount("#app");